module.exports = __webpack_public_path__ + "media/images/background/background-login-2-9ffd7c52dcb7c82bfd7701a895de59fa.png";